function hideDefaultVariants() {
  document.querySelectorAll('.xb-list-style__variant-wrapper').forEach(function(wrapper) {
    var select = wrapper.querySelector('select');
    if (select && select.options.length === 1 && select.options[0].text.trim() === 'Default') {
      wrapper.style.display = 'none';
    }
  });
}

setTimeout(hideDefaultVariants, 500);
setTimeout(hideDefaultVariants, 1500);
setTimeout(hideDefaultVariants, 3000);

const observer = new MutationObserver(hideDefaultVariants);
observer.observe(document.body, { childList: true, subtree: true });

// Warenkorb-Icon in Wishlist "Add to cart" Buttons
function replaceAddToCartIcon() {
  const cartIcon = document.querySelector('#cart-icon-bubble .svg-wrapper');
  const addToCartButtons = document.querySelectorAll('.xb-list-style__add-to-cart');
  
  if (cartIcon && addToCartButtons.length > 0) {
    addToCartButtons.forEach(function(btn) {
      btn.innerHTML = cartIcon.innerHTML;
      btn.style.opacity = '1';
    });
    return true;
  }
  return false;
}

// Buttons sofort verstecken
document.addEventListener('DOMContentLoaded', function() {
  const style = document.createElement('style');
  style.textContent = '.xb-list-style__add-to-cart { opacity: 0; transition: opacity 0.2s; }';
  document.head.appendChild(style);
});

setTimeout(replaceAddToCartIcon, 300);
setTimeout(replaceAddToCartIcon, 800);
setTimeout(replaceAddToCartIcon, 2000);
